import type { ApiResponseBody } from '@/lib/api/api-type-helper';
import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';

export type GetHighlyConfidentialValueResponse = ApiResponseBody<
  '/v2/operation-instances/highly-confidential/tasks/{operationTaskInstanceId}/fields/{fieldKey}',
  'get'
>;

/**
 * 高機密値を取得
 * 暗号化された高機密値を復号化して取得します
 */
export const getHighlyConfidentialValue = async (
  operationTaskInstanceId: string,
  fieldKey: string,
): Promise<GetHighlyConfidentialValueResponse> => {
  const res = await apiClient.GET(
    '/v2/operation-instances/highly-confidential/tasks/{operationTaskInstanceId}/fields/{fieldKey}',
    {
      params: {
        path: {
          operationTaskInstanceId,
          fieldKey,
        },
      },
    },
  );
  return getDataOrThrowApiError(res);
};

/**
 * 高機密ファイル内容を取得して Blob URL を作成
 * S3 URL を基に高機密ファイルの内容を取得
 */
export const getHighlyConfidentialFileContent = async (
  s3Url: string,
  originalName: string,
  mimeType: string,
): Promise<string> => {
  const response = await apiClient.GET(
    '/v2/highly-confidential-file/download',
    {
      params: {
        query: {
          s3Url,
          originalName,
          mimeType,
        },
      },
      parseAs: 'blob', // レスポンスを Blob として取得
    },
  );

  if (!response.response.ok) {
    throw new Error(
      `高機密ファイルの取得に失敗しました: ${response.response.status} ${response.response.statusText}`,
    );
  }

  if (!response.data) {
    throw new Error('高機密ファイルデータが取得できませんでした');
  }

  const blob = response.data as Blob;
  const blobUrl = URL.createObjectURL(blob);

  return blobUrl;
};
